module.exports = __webpack_public_path__ + "static/img/kedge-business-school.6a8f439.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main_supporters/kedge-business-school.jpg
// module id = hyH3
// module chunks = 1